// extracted by mini-css-extract-plugin
export var circle = "_10-2";
export var icon = "_10-a";
export var iconHighlight = "_10-0";
export var lg = "_10-8";
export var md = "_10-7";
export var outline = "_10-4";
export var sm = "_10-6";
export var square = "_10-1";
export var xl = "_10-9";
export var xs = "_10-5";
export var xxs = "_10-3";